import type {
  Verification,
  VerificationType,
  VerificationDetails,
  VerificationStatusType,
} from '../../../../../components/PageWrappers/AdDetails/components/Verifications/Verifications.typed';

import {
  VerifiedBadgeFilledIc,
  VerifiedBadgeOutlineIc,
  RemoveIc,
} from '@dsch/dd-icons';
import { VerificationStatus } from '../../../../../components/PageWrappers/AdDetails/components/Verifications/Verifications.typed';
import { DefaultTheme } from 'styled-components';

const getVerificationStatus = (
  verifications: Verification,
): VerificationStatusType => {
  const basicVerified =
    verifications.email ||
    verifications.phone ||
    verifications.bank ||
    ((verifications.email || verifications.phone) && verifications.bank);

  const partialVerified = verifications.email && verifications.phone;
  const fullyVerified =
    verifications.email && verifications.phone && verifications.bank;

  if (fullyVerified) {
    return VerificationStatus.FullyVerified;
  }
  if (partialVerified) {
    return VerificationStatus.PartialVerified;
  }
  if (basicVerified) {
    return VerificationStatus.BasicVerified;
  }
  return VerificationStatus.NotVerified;
};

const getVerificationDetails = (
  verifications: Verification,
): VerificationDetails => {
  const { email = false, phone = false, bank = false } = verifications;

  const verified: VerificationType[] = [];
  if (email) verified.push('Email');
  if (phone) verified.push('Phone');
  if (bank) verified.push('Payment card');

  return {
    iconStatus: getVerificationStatus(verifications),
    statusText: verified.join(', '),
  };
};

export const getVerificationIconsAndText = (
  theme: DefaultTheme,
  size: 'small' | 'medium' = 'small',
) => {
  const iconSize = size === 'medium' ? 20 : 16;

  return {
    'not-verified': {
      icon: (
        <RemoveIc
          data-testid="not-verified-icon"
          color={theme.colors.GREY_DARK}
          width={iconSize}
          height={iconSize}
        />
      ),
      text: 'No details verified yet',
    },
    'basic-verified': {
      icon: (
        <VerifiedBadgeOutlineIc
          data-testid="basic-verified-icon"
          color={theme.colors.GREY}
          width={iconSize}
          height={iconSize}
        />
      ),
      text: 'Basic verification: ',
    },
    'partial-verified': {
      icon: (
        <VerifiedBadgeOutlineIc
          data-testid="partial-verified-icon"
          color={theme.colors.GREEN_DARK}
          width={iconSize}
          height={iconSize}
        />
      ),
      text: 'Partial verification: ',
    },
    'fully-verified': {
      icon: (
        <VerifiedBadgeFilledIc
          data-testid="fully-verified-icon"
          color={theme.colors.GREEN_DARK}
          width={iconSize}
          height={iconSize}
        />
      ),
      text: 'Full verification: ',
    },
  };
};

export { getVerificationDetails };
